import { useMemo } from "react";
import { useSelector } from "react-redux";

const useRole = () => {
  const role = useSelector((state) => state?.auth?.details?.role);
  return useMemo(() => role, [role]);
};

export default useRole;
